import React from 'react'
import logo from '../images/nc_logo1.png'
import jnu from '../images/jnu_logo.png'
import { Link } from 'react-router-dom'
import Committee from '../Committee/Committee'

function Navbar() {
  return (
    <nav class="navbar navbar-expand-lg bg-body-tertiary shadow sticky-top">
        <div class="container-fluid">
          <a class="navbar-brand" href="#">
            <img src={logo} alt="Logo" width="70" height="70" class="me-2" />
            <strong>NET<span style={{color:"orangered"}}>CRYPT</span> </strong>
          </a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-5 mb-2 mb-lg-0">
              <li class="nav-item mx-1">
                <Link to="/" class="nav-link" aria-current="page"><span><strong>Home</strong></span></Link>
              </li>
              <li class="nav-item mx-1">
                <Link to="/Committee" class="nav-link"><span><strong>Committee</strong></span> </Link>
              </li>

              <li class="nav-item dropdown mx-1">
                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <span><strong>Call for Paper</strong></span> 
                </a>
                <ul class="dropdown-menu">
                  <li><Link to="/tracks" class="dropdown-item">Tracks</Link></li>
                  <li><Link to='/guidelines' class="dropdown-item">Guidelines</Link></li>
                  <li><hr class="dropdown-divider" /></li>
                  <li><Link to='/submission' class="dropdown-item">Paper submission</Link></li>
                </ul>
              </li>

              {/* <li class="nav-item mx-1">
                <Link to='/special_sessions' class="nav-link"><span><strong>Special Sessions</strong></span> </Link>
              </li> */}

              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <span><strong>Special Sessions</strong></span> 
                </a>
                <ul class="dropdown-menu">
                  <Link to='/Special' class="nav-link"><span><strong>Special Sessions</strong></span> </Link>
                  <li><hr class="dropdown-divider" /></li>
                  <Link to='/special_sessions' class="nav-link"><span><strong>Call for Special Session</strong></span> </Link>
                </ul>
              </li>

              <li class="nav-item">
                <Link to='/speakers' class="nav-link"><span><strong>Speakers</strong></span> </Link>
              </li>

              <li class="nav-item">
                <Link to='/registration' class="nav-link"><span><strong>Registration</strong></span></Link>
              </li>
              <li class="nav-item">
                <Link to='/schedule' class="nav-link"><span><strong>Conference Schedule</strong></span></Link>
              </li>
              <li class="nav-item">
                <Link to='/previous_conferences' class="nav-link"><span><strong>Previous Conferences</strong></span> </Link>
              </li>

              <li class="nav-item">
                <Link to='/contact_loc' class="nav-link"><span><strong>Contacts</strong></span> </Link>
              </li>
              
            </ul>
            <Link to='https://cmt3.research.microsoft.com/NETCRYPT2026' class="btn btn-primary" style={{backgroundColor:"orangered"}} target="_blank">Submit your paper</Link>
          </div>
        </div>
    </nav>

  )
}

export default Navbar